/**
 * SAVAGE CLIMBING: Подравняване на продуктовите картички по редове
 * ------------------------------------------------------------------
 * Описание: Намира всички .card__information блокове, групира ги по
 *           редове спрямо Y-позицията им и уеднаквява височината им.
 * ------------------------------------------------------------------
 */
function fixCardHeights() {
  // 1. Намираме абсолютно всички .card на страницата
  const allCards = Array.from(document.querySelectorAll('.card'));
  if (!allCards.length) return;

  const infoBlocks = [];

  allCards.forEach(card => {
    // Намираме външния .card__content (който НЕ е вътре в .card__inner)
    const outerContent = Array.from(card.children).find(child => child.classList.contains('card__content'));
    if (outerContent) {
      const info = outerContent.querySelector('.card__information');
      if (info) infoBlocks.push(info);
    }
  });

  if (!infoBlocks.length) return;

  // 2. Връщаме им auto за чиста измерена височина
  infoBlocks.forEach(block => {
    block.style.minHeight = 'auto';
  });

  // 3. Групираме по редове спрямо реалната им Y-позиция на екрана (+/- 15px толеранс)
  const rows = [];
  infoBlocks.forEach(block => {
    const top = Math.round(block.getBoundingClientRect().top);
    let row = rows.find(r => Math.abs(r.top - top) < 15);
    if (!row) {
      row = { top: top, blocks: [] };
      rows.push(row);
    }
    row.blocks.push(block);
  });

  // 4. Прилагаме най-голямата височина за всеки ред поотделно
  rows.forEach(row => {
    if (row.blocks.length <= 1) return; // Игнорираме единични картички

    let maxHeight = 0;
    row.blocks.forEach(block => {
      if (block.offsetHeight > maxHeight) {
        maxHeight = block.offsetHeight;
      }
    });

    if (maxHeight > 0) {
      row.blocks.forEach(block => {
        block.style.minHeight = maxHeight + 'px';
      });
    }
  });
}

// Задвижване
window.addEventListener('load', fixCardHeights);
window.addEventListener('resize', fixCardHeights);

// Таймаути за зареждане на отзивите (Loox, Judge.me)
setTimeout(fixCardHeights, 500);
setTimeout(fixCardHeights, 1200);
setTimeout(fixCardHeights, 2500);

// Глобално наблюдение за динамично заредени компоненти и филтри
const cardObserver = new MutationObserver(fixCardHeights);
cardObserver.observe(document.body, { childList: true, subtree: true });